import { connect } from 'react-redux'
import { notify } from 'actions/account'

const mapStateToProps = () => ({})

const withRedux = connect(
  mapStateToProps,
  { notify }
)

export default withRedux
